import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../../../types/store';

import { isCurrentUserProfileOwner, getProfileOwnerUser } from '../../../../../selectors/users';

import { Props } from './EmptyState';

type StateProps = Pick<Props, 'isOwner' | 'user'>;
type DispatchProps = Pick<Props, 'onOpenChat'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => ({
  isOwner: isCurrentUserProfileOwner(state),
  user: getProfileOwnerUser(state),
});

export default connect(mapStateToProps);
